/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-plusplus */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useContext, useEffect } from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { usePatch,
  getGridTargetTitleDetails,
  getLocationTargetErrorMessage,
  getLocationTargetTitleDetails,
  globalErrorMsg, } from '@bingads-webui-campaign/hotel-common-upsert';
import { ErrorString } from '@bingads-webui-campaign-react/wizard-shared-components';
import { Collapse, ToggleTitle } from '@bingads-webui-campaign/wizard-jumbo-card';
import { Link, Stack, DefaultButton } from '@bingads-webui-react/fabric-control';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import {
  AdvancedBookingWindowTargetSetting,
  CheckinDayTargetSetting,
  UserSetDatesTargetSetting,
  CheckinDateTargetSetting,
  LengthOfStayTargetSetting,
  DeviceTargetSetting,
  LocationTargetSetting,
} from '@bingads-webui-campaign/hotel-common-targets';

import { getUnSupportedBidAdjustmentFeatures } from '../util';
import { defaultAdgroupBasicData } from './default-value';

const getStyles = () => ({
  AdgroupTargets: {
    marginTop: '40px',
  },
  title: {
    fontWeight: 600,
    fontSize: '20px',
  },
  subtitle: {
    marginBottom: '16px',
    fontSize: '20px',
  },
  mt33: {
    marginTop: '33px',
  },
});


export const AdgroupTargets = (props) => {
  const {
    adgroup,
    campaign,
    errMsg,
    patchAdgroup,
    patchErrMsg,
    targetsApiErrors,
    patchTargetsApiErrMsg,
  } = props;
  const classes = useDefaultStyles(getStyles);

  const i18n = useContext(I18nContext);
  const serverContext = useContext(ServerContext);

  const campaignBidStrategyType = campaign && campaign.bidStrategy && campaign.bidStrategy.option;
  const unSupportedFeatures = getUnSupportedBidAdjustmentFeatures(campaignBidStrategyType);

  const allPanelItems = _.reject(['location', 'device', 'ABW', 'checkinDay', 'lengthOfStay', 'checkinDate', 'userSetDates'], x => unSupportedFeatures.includes(x));

  const [activeKeys, setActiveKeys] = useState(_.reject(['location', 'device'], x => unSupportedFeatures.includes(x)));
  useEffect(() => {
    const hasApiErrorKeys = Object.keys(targetsApiErrors);
    const needToExpandKeys = [];
    allPanelItems.forEach((key) => {
      if (hasApiErrorKeys.includes(key) && targetsApiErrors[key] && targetsApiErrors[key].length) {
        patchErrMsg(key, globalErrorMsg);
        needToExpandKeys.push(key);
      }
    });
    setActiveKeys(activeKeys.concat(needToExpandKeys));
  }, [targetsApiErrors]);

  const onCollapseAll = () => {
    if (activeKeys.length) {
      setActiveKeys([]);
    } else {
      setActiveKeys(allPanelItems);
    }
  };

  const setLocation = usePatch(patchAdgroup, 'location');
  const setDevice = usePatch(patchAdgroup, 'device');
  const setABW = usePatch(patchAdgroup, 'ABW');
  const setCheckinDay = usePatch(patchAdgroup, 'checkinDay');
  const setUserSetDates = usePatch(patchAdgroup, 'userSetDates');
  const setCheckinDate = usePatch(patchAdgroup, 'checkinDate');
  const setLengthOfStay = usePatch(patchAdgroup, 'lengthOfStay');

  const {
    device, ABW, checkinDay, lengthOfStay, checkinDate, userSetDates, location,
  } = adgroup;

  const {
    device: { currentLevelSettings: deviceDefaultCurrentLevelSettings },
    ABW: { currentLevelSettings: ABWDefaultCurrentLevelSettings },
    checkinDay: { currentLevelSettings: checkinDayDefaultCurrentLevelSettings },
    lengthOfStay: { currentLevelSettings: lengthOfStayDefaultCurrentLevelSettings },
    checkinDate: { currentLevelSettings: checkinDateDefaultCurrentLevelSettings },
    userSetDates: { currentLevelSettings: userSetDatesDefaultCurrentLevelSettings },
  } = defaultAdgroupBasicData;

  // Turn off --- you set nothing, you use default settings inherited from campaign
  // Turn on --- you override the campaign settings
  const onChangeToggle = (fn, key, value) => {
    fn({ ...adgroup[key], useParentLevel: !value });
  };

  const resetTarget = (setFn, targetData, targetDefaultCurrentLevelSettings, targetName) => {
    let tempCurrentLevelSettings = [...targetData.currentLevelSettings];
    for (let i = 0; i < tempCurrentLevelSettings.length; i++) {
      if (tempCurrentLevelSettings[i]) {
        const tempId = tempCurrentLevelSettings[i].Id;
        const tempObj = { ...targetDefaultCurrentLevelSettings[i] };
        if (tempCurrentLevelSettings[i].Id) {
          tempCurrentLevelSettings[i] = tempObj;
          tempCurrentLevelSettings[i].Id = tempId;
          tempCurrentLevelSettings[i].Status = 'Deleted';
        } else {
          tempCurrentLevelSettings.splice(i, 1);
          i--;
        }
      }
    }
    tempCurrentLevelSettings = targetDefaultCurrentLevelSettings.concat(tempCurrentLevelSettings);
    setFn({ ...targetData, currentLevelSettings: tempCurrentLevelSettings, reset: true });
    patchTargetsApiErrMsg(targetName, []);
  };

  const locationTitle = (<ToggleTitle
    titleKey={_TL_('Location')}
    topicKey="pop_BA_AdGroup_Settings_LocationTargeting"
    details={getLocationTargetTitleDetails(i18n, location, true)}
    isChecked={!location.useParentLevel}
    handleChangeToggle={(_e, value) => {
      const isTargetEverywhere = adgroup.location.currentLevelSettings.currentLocations == null ||
        adgroup.location.currentLevelSettings.currentLocations.length === 0;
      if (adgroup.location.useParentLevel === true &&
        isTargetEverywhere) {
        const campaignLocations = _.deepClone(location.parentLevelSettings.currentLocations);
        _.map(campaignLocations, (campaignLocation) => {
          const target = campaignLocation;
          target.Campaign = null;
          delete target.Id;
          return target;
        });
        setLocation({
          ...adgroup.location,
          currentLevelSettings: {
            ...adgroup.location.currentLevelSettings,
            currentLocations: campaignLocations,
            peopleInLocation: true,
            peopleSearchingForLocation: true,
          },
          useParentLevel: false,
          bidMode: true,
          errors: undefined,
        });
      } else if (adgroup.location.useParentLevel === true) {
        setLocation({
          ...adgroup.location,
          useParentLevel: false,
          bidMode: true,
          errors: undefined,
        });
      } else {
        setLocation({
          ...adgroup.location,
          useParentLevel: !value,
          errors: undefined,
        });
      }
    }}
  />);

  const formatDateValue = value => i18n.formatDate(value, { raw: serverContext.CurrentUser.CultureDateTimeFormat.ShortDatePattern });
  const deviceTitle = <ToggleTitle titleKey={_TL_('Device')} topicKey="pop_BA_CampaignCreate_AudTargets_Device" details={getGridTargetTitleDetails(i18n, device)} isChecked={!device.useParentLevel} handleChangeToggle={(_e, value) => { onChangeToggle(setDevice, 'device', value); }} />;
  const abwTitle = <ToggleTitle titleKey={_TL_('Advanced booking window')} topicKey="pop_BA_AdGroupCreate_Settings_ABWTargeting" details={getGridTargetTitleDetails(i18n, ABW, '-')} isChecked={!ABW.useParentLevel} handleChangeToggle={(_e, value) => { onChangeToggle(setABW, 'ABW', value); }} />;
  const checkinDayTitle = <ToggleTitle titleKey={_TL_('Check-in day')} topicKey="pop_BA_AdGroupCreate_Settings_CheckinDayTargeting" details={getGridTargetTitleDetails(i18n, checkinDay)} isChecked={!checkinDay.useParentLevel} handleChangeToggle={(_e, value) => { onChangeToggle(setCheckinDay, 'checkinDay', value); }} />;
  const lengthOfStayTitle = <ToggleTitle titleKey={_TL_('Length of stay')} topicKey="pop_BA_AdGroupCreate_Settings_LengthOfStayTargeting" details={getGridTargetTitleDetails(i18n, lengthOfStay, '-')} isChecked={!lengthOfStay.useParentLevel} handleChangeToggle={(_e, value) => { onChangeToggle(setLengthOfStay, 'lengthOfStay', value); }} />;
  const checkinDateTitle = <ToggleTitle titleKey={_TL_('Check-in date')} topicKey="pop_BA_AdGroupCreate_Settings_CheckinDateTargeting" details={getGridTargetTitleDetails(i18n, checkinDate, '-', formatDateValue)} isChecked={!checkinDate.useParentLevel} handleChangeToggle={(_e, value) => { onChangeToggle(setCheckinDate, 'checkinDate', value); }} />;
  const userSetDatesTitle = <ToggleTitle titleKey={_TL_('User set dates')} topicKey="pop_BA_AdGroupCreate_Settings_UserSetDatesTargeting" details={getGridTargetTitleDetails(i18n, userSetDates)} isChecked={!userSetDates.useParentLevel} handleChangeToggle={(_e, value) => { onChangeToggle(setUserSetDates, 'userSetDates', value); }} />;

  return allPanelItems.length <= 0 ? null : (
    <div className={classnames('adgroup-targets-section', classes.AdgroupTargets)}>
      <div>
        <div className={classes.title}>
          {i18n.getString(_TL_('Ad group targets'))}
        </div>
        <Stack horizontal horizontalAlign="space-between" tokens={{ padding: '0 0 12px 0' }}>
          <span className={classes.description}> {i18n.getString(_TL_('Who do you want to target for this ad group? You can select any combination of the criteria below. '))}</span>
          <Link className="jumbo-card-control-all-btn" onClick={onCollapseAll}>{activeKeys.length ? i18n.getString(_TL_('Collapse all')) : i18n.getString(_TL_('Expand all'))}</Link>
        </Stack>
      </div>

      <Collapse allPanelItems={allPanelItems} checkItems activeKeys={activeKeys} setActiveKeys={setActiveKeys}>
        <Collapse.Panel key="location" title={locationTitle} error={getLocationTargetErrorMessage(location)}>
          <LocationTargetSetting
            data={location}
            setData={setLocation}
            isAdGroupLevel
            scope={props.scope}
          />
        </Collapse.Panel>
        <Collapse.Panel key="device" title={deviceTitle} error={errMsg.device}>
          <DeviceTargetSetting data={device} setData={setDevice} patchErrMsg={patchErrMsg} patchTargetsApiErrMsg={patchTargetsApiErrMsg} apiErrors={targetsApiErrors.device} />
          {!device.useParentLevel && targetsApiErrors.device && targetsApiErrors.device.map(item => (<ErrorString error={item} />))}
          <Stack horizontal horizontalAlign="end" className={classes.mt33}>
            <DefaultButton text={i18n.getString(_TL_('Reset'))} disabled={device.useParentLevel} onClick={() => { resetTarget(setDevice, device, deviceDefaultCurrentLevelSettings, 'device'); }} />
          </Stack>
        </Collapse.Panel>
        <Collapse.Panel key="ABW" title={abwTitle} error={errMsg.ABW}>
          <AdvancedBookingWindowTargetSetting data={ABW} setData={setABW} errMsg={errMsg} patchErrMsg={patchErrMsg} patchTargetsApiErrMsg={patchTargetsApiErrMsg} apiErrors={targetsApiErrors.ABW} />
          {!ABW.useParentLevel && targetsApiErrors.ABW && targetsApiErrors.ABW.map(item => (<ErrorString error={item} />))}
          <Stack horizontal horizontalAlign="end" className={classes.mt33}>
            <DefaultButton text={i18n.getString(_TL_('Reset'))} disabled={ABW.useParentLevel} onClick={() => { resetTarget(setABW, ABW, ABWDefaultCurrentLevelSettings, 'ABW'); }} />
          </Stack>
        </Collapse.Panel>
        <Collapse.Panel key="checkinDay" title={checkinDayTitle} error={errMsg.checkinDay}>
          <CheckinDayTargetSetting data={checkinDay} setData={setCheckinDay} patchErrMsg={patchErrMsg} patchTargetsApiErrMsg={patchTargetsApiErrMsg} apiErrors={targetsApiErrors.checkinDay} />
          {!checkinDay.useParentLevel && targetsApiErrors.checkinDay && targetsApiErrors.checkinDay.map(item => (<ErrorString error={item} />))}
          <Stack horizontal horizontalAlign="end" className={classes.mt33}>
            <DefaultButton text={i18n.getString(_TL_('Reset'))} disabled={checkinDay.useParentLevel} onClick={() => { resetTarget(setCheckinDay, checkinDay, checkinDayDefaultCurrentLevelSettings, 'checkinDay'); }} />
          </Stack>
        </Collapse.Panel>
        <Collapse.Panel key="lengthOfStay" title={lengthOfStayTitle} error={errMsg.lengthOfStay}>
          <LengthOfStayTargetSetting data={lengthOfStay} setData={setLengthOfStay} patchErrMsg={patchErrMsg} patchTargetsApiErrMsg={patchTargetsApiErrMsg} apiErrors={targetsApiErrors.lengthOfStay} />
          {!lengthOfStay.useParentLevel && targetsApiErrors.lengthOfStay && targetsApiErrors.lengthOfStay.map(item => (<ErrorString error={item} />))}
          <Stack horizontal horizontalAlign="end" className={classes.mt33}>
            <DefaultButton text={i18n.getString(_TL_('Reset'))} disabled={lengthOfStay.useParentLevel} onClick={() => { resetTarget(setLengthOfStay, lengthOfStay, lengthOfStayDefaultCurrentLevelSettings, 'lengthOfStay'); }} />
          </Stack>
        </Collapse.Panel>
        <Collapse.Panel key="checkinDate" title={checkinDateTitle} error={errMsg.checkinDate}>
          <CheckinDateTargetSetting data={checkinDate} setData={setCheckinDate} patchErrMsg={patchErrMsg} patchTargetsApiErrMsg={patchTargetsApiErrMsg} apiErrors={targetsApiErrors.checkinDate} />
          {!checkinDate.useParentLevel && targetsApiErrors.checkinDate && targetsApiErrors.checkinDate.map(item => (<ErrorString error={item} />))}
          <Stack horizontal horizontalAlign="end" className={classes.mt33}>
            <DefaultButton text={i18n.getString(_TL_('Reset'))} disabled={checkinDate.useParentLevel} onClick={() => { resetTarget(setCheckinDate, checkinDate, checkinDateDefaultCurrentLevelSettings, 'checkinDate'); }} />
          </Stack>
        </Collapse.Panel>
        <Collapse.Panel key="userSetDates" title={userSetDatesTitle} error={errMsg.userSetDates}>
          <UserSetDatesTargetSetting data={userSetDates} setData={setUserSetDates} patchErrMsg={patchErrMsg} patchTargetsApiErrMsg={patchTargetsApiErrMsg} apiErrors={targetsApiErrors.userSetDates} />
          {!userSetDates.useParentLevel && targetsApiErrors.userSetDates && targetsApiErrors.userSetDates.map(item => (<ErrorString error={item} />))}
          <Stack horizontal horizontalAlign="end" className={classes.mt33}>
            <DefaultButton text={i18n.getString(_TL_('Reset'))} disabled={userSetDates.useParentLevel} onClick={() => { resetTarget(setUserSetDates, userSetDates, userSetDatesDefaultCurrentLevelSettings, 'userSetDates'); }} />
          </Stack>
        </Collapse.Panel>
      </Collapse>
    </div>);
};

AdgroupTargets.propTypes = {
  adgroup: PropTypes.shape({}),
  campaign: PropTypes.shape({}).isRequired,
  errMsg: PropTypes.shape({}),
  patchAdgroup: PropTypes.func.isRequired,
  patchErrMsg: PropTypes.func.isRequired,
  scope: PropTypes.shape({
    values: PropTypes.shape({
      cid: PropTypes.number.isRequired,
      aid: PropTypes.number.isRequired,
      campaignId: PropTypes.number,
    }).isRequired,
  }).isRequired,
  targetsApiErrors: PropTypes.shape({}),
  patchTargetsApiErrMsg: PropTypes.func,
};

AdgroupTargets.defaultProps = {
  adgroup: {},
  errMsg: {},
  targetsApiErrors: {},
  patchTargetsApiErrMsg() {},
};
